export const GET_DASHBOARD = 'GET_DASHBOARD'
export const LOGIN = 'LOGIN'
export const LOGOUT = 'RESET_REDUX'
export const SET = 'set'
export const SET_LOADER = 'SET_LOADER'
export const GET_SCOPE = 'GET_SCOPE'
export const GET_CATEGORY = 'GET_CATEGORY'
export const GET_BRANCH = 'GET_BRANCH'
export const GET_BRANCH_UPLOAD = 'GET_BRANCH_UPLOAD'
export const GET_DATA_EMISSION_SCOPE_3 = 'GET_DATA_EMISSION_SCOPE_3'
export const GET_ALL_NOTIFICATIONS = 'GET_ALL_NOTIFICATIONS'
export const SET_TUTORIAL = 'SET_TUTORIAL'
export const RESET_TUTORIAL = 'RESET_TUTORIAL'
export const SET_CURRENT_YEAR = 'SET_CURRENT_YEAR'
export const SET_PREMIUM = 'SET_PREMIUM'
export const SET_HAS_UNREAD_NOTI = 'SET_HAS_UNREAD_NOTI'
export const SET_CURRENT_COMPANY = 'SET_CURRENT_COMPANY'
export const SET_GOAL_STRATEGIES = 'SET_GOAL_STRATEGIES'
export const SET_VERSION = 'SET_VERSION'
export const SET_CLASSIFICATION_ELECTRIC_ID = 'SET_CLASSIFICATION_ELECTRIC_ID'
export const SET_EMISSIONS = 'SET_EMISSIONS'
export const SET_HIDDEN_COLUMNS = 'SET_HIDDEN_COLUMNS'
export const SET_SEARCH_PARAMS_REGISTRATION_DATA =
  'SET_SEARCH_PARAMS_REGISTRATION_DATA'
export const SET_ABOUT_ME = 'SET_ABOUT_ME'
export const SET_EMISSION_BASED = 'SET_EMISSION_BASED'
